import { getModulesData } from "../selectors";
import { getCallbackRequestTexts } from "../shared/selectors";
export var selectCheckboxAgreementText = function selectCheckboxAgreementText(state) {
  return getCallbackRequestTexts(state).userAgreementText;
};
export var selectCheckboxAgreementData = function selectCheckboxAgreementData(state) {
  return getModulesData(state).checkboxAgreement;
};
export var selectIsCheckboxChecked = function selectIsCheckboxChecked(state) {
  return selectCheckboxAgreementData(state).isCheckboxChecked;
};